(function($) {
    function handleCounters() {
        $('.case-studies-block .csb-mainwrap').each(function() {
            if (isPartiallyVisible($(this))) {
                startCounters($(this));
            }
        });
    }

    function startCounters(elem) {
        const spMainSec = $(elem);
        if (spMainSec.length) {
            const sectionTop = spMainSec.offset().top;
            const windowHeight = $(window).height();
            const counterAnimated = spMainSec.data('counter-animated');
            const scrollTop = $(window).scrollTop();

            if (!counterAnimated && scrollTop + windowHeight > sectionTop + 100) {
                spMainSec.find('.stat-counter').each(function() {
                    const spCounter = $(this);

                    if (!spCounter.hasClass('counted')) {
                        const originalValue = spCounter.data('count').toString();
                        const cleanedValue = originalValue.replace(/[^0-9.]/g, '');
                        const finalValue = parseFloat(cleanedValue);

                        if (!isNaN(finalValue)) {
                            const duration = finalValue < 10 ? 800 : 1200;
                            spCounter.text('0');

                            $({
                                counter: 0,
                            }).animate({
                                counter: finalValue,
                            }, {
                                duration,
                                easing: 'swing',
                                step: function(now) {
                                    const formatted = applyCustomFormat(
                                        originalValue,
                                        now.toFixed(getDecimalPlaces(originalValue)),
                                    );
                                    spCounter.text(formatted);
                                },
                                complete: function() {
                                    spCounter.text(originalValue);
                                    spCounter.addClass('counted');
                                },
                            });
                        }
                    }
                });

                spMainSec.data('counter-animated', true);
            }
        }
    }

    function getDecimalPlaces(number) {
        const parts = number.split('.');
        return parts.length > 1 ? parts[1].length : 0;
    }

    function applyCustomFormat(originalValue, currentNumber) {
        const originalParts = originalValue.split('.');
        const integerPart = originalParts[0];
        const decimalPart = originalParts[1] || '';

        const reversed = currentNumber.split('.')[0].split('').reverse();
        const formatted = [];
        let index = 0;

        const originalIntParts = integerPart.includes(',') ? integerPart.split(',') : [integerPart];
        for (let i = 0; i < originalIntParts.length; i++) {
            const partLength = originalIntParts[i].length;
            const part = reversed.slice(index, index + partLength).reverse().join('');
            formatted.push(part);
            index += partLength;
        }

        const formattedInt = formatted.join(',');
        const currentDecimal = currentNumber.split('.')[1] || '';

        return decimalPart ? formattedInt + '.' + currentDecimal : formattedInt;
    }

    function isPartiallyVisible(element) {
        const elementTop = element.offset().top;
        const elementBottom = elementTop + element.outerHeight();
        const viewportTop = $(window).scrollTop();
        const viewportBottom = viewportTop + $(window).height();

        return elementBottom > viewportTop && elementTop < viewportBottom;
    }

    // Initialize
    $(window).on('load scroll resize', handleCounters);
})(jQuery);
